import React, { useContext, useState } from "react";
import { useDispatch } from "react-redux";
import { Timeout, formattedDate } from "../../functions/functions";
import { ExpenseInterface, DataExpenseContext, ShowExpenseContext } from "./types";
import { EditExpenseApi } from "../../redux/expense/expenseApiCalls";
import ShowErrorMsg from "../../HtmlComponents/ShowErrorMsg";
import ButtonsForm from "../../HtmlComponents/ButtonsForm";
import InputsExpenses from "./forms/InputsExpenses";

interface props {
  modal: boolean,
  toggle: any,
  selectedExpense: ExpenseInterface
}

const EditExpense = ({ modal, toggle, selectedExpense }: props) => {
  const [note, setNote] = useState(selectedExpense.note);
  const [amount, setAmount] = useState(selectedExpense.amount);
  const [createdAt, setCreatedAt] = useState(formattedDate(selectedExpense.createdAt));

  const [errors, setErrors] = useState([]);
  
  const dispatch: any = useDispatch();

  const { setShowSuccessMsg } = useContext(ShowExpenseContext)

  const [loading, setLoading] = useState(false)
    
  const handleSubmitExpense = async (e: any) => {
    e.preventDefault();
    setLoading(true)
    try {
      const response: any = await dispatch(EditExpenseApi(selectedExpense._id, { note, amount, createdAt }));
      if (response === true) {
        toggle();
        setShowSuccessMsg(true);
        setTimeout(() => setShowSuccessMsg(false), Timeout);
        setNote("");
        setAmount("");
        setErrors([]);
      } else {
        setErrors(response);
      }
    } finally {
      setLoading(false)
    }
  };

  return (
    <DataExpenseContext.Provider value={{
      note, setNote,
      amount, setAmount,
      createdAt, setCreatedAt
    }}>
      {modal && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
              className="fixed inset-0 w-full h-full bg-black opacity-40"
              onClick={toggle}
            ></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full max-w-lg p-4 mx-auto bg-white rounded-md shadow-lg">
                <div className="mt-3">
                  {/* Start Modal Body */}
                  <form
                    className="mt-2 sm:ml-4 sm:text-left"
                    onSubmit={handleSubmitExpense}
                  >
                    <ShowErrorMsg errors={errors} setErrors={setErrors} />
                    <InputsExpenses />
                    <ButtonsForm loading={loading} typeBtn="Modifier" toggle={toggle} />
                  </form>
                  {/* End Modal Body */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </DataExpenseContext.Provider>
  );
};

export default EditExpense;
